import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { Product } from '@df/catalog/product/product';
import { RouteResolver } from '@df/catalog/route/route.resolver';
import { VipService } from '../module/vip/vip.service';
export const catalogRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import(
                /* webpackChunkName: "catalog-view.async" */
                './ui/catalog-view.component'
            ).then(m => m.CatalogViewComponent),
        resolve: {
            route: async (activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) => {
                const routeResolver = inject(RouteResolver);
                const vipService = inject(VipService);
                const route = await routeResolver.resolve(activatedRouteSnapshot, routerStateSnapshot);
                const target = route.target;
                if (target?.type === Product.type) {
                    if (await vipService.loadAndCheckProduct(target as Product)) {
                        return route;
                    }
                }
                return route;
            }
        },
        data: {
            preload: true
        }
    }
];
